import { axiosB2 } from './axiosB2';

/**
 * Set marketing consent for one account (company). B2: SetMarketingConsentAccount
 * @param {{ id: number, marketingStatusId: number }} params
 */
export function setMarketingConsentAccount({ id, marketingStatusId }) {
    return axiosB2
        .post('SetMarketingConsentAccount', {
            id: Number(id),
            marketingStatusId: Number(marketingStatusId),
        })
        .then(({ data }) => {
            const parsed = typeof data === 'string' ? JSON.parse(data) : data;
            if (parsed == null) {
                throw new Error('Empty B2 response');
            }
            const state = parsed.State ?? parsed.state;
            if (state !== undefined && state !== null && state !== '1' && state !== 1) {
                const msg = parsed.Message || parsed.message || 'B2 error';
                throw new Error(typeof msg === 'string' ? msg : 'B2 error');
            }
            if (parsed.data !== undefined) {
                return parsed.data;
            }
            if (parsed.Result !== undefined) {
                return parsed.Result;
            }
            return parsed;
        });
}

/**
 * Set marketing consent for one contact. B2: SetMarketingConsentContact
 * @param {{ id: number, marketingStatusId: number }} params
 */
export function setMarketingConsentContact({ id, marketingStatusId }) {
    return axiosB2
        .post('SetMarketingConsentContact', {
            id: Number(id),
            marketingStatusId: Number(marketingStatusId),
        })
        .then(({ data }) => {
            const parsed = typeof data === 'string' ? JSON.parse(data) : data;
            if (parsed == null) {
                throw new Error('Empty B2 response');
            }
            const state = parsed.State ?? parsed.state;
            if (state !== undefined && state !== null && state !== '1' && state !== 1) {
                const msg = parsed.Message || parsed.message || 'B2 error';
                throw new Error(typeof msg === 'string' ? msg : 'B2 error');
            }
            if (parsed.data !== undefined) {
                return parsed.data;
            }
            if (parsed.Result !== undefined) {
                return parsed.Result;
            }
            return parsed;
        });
}
